import React, { useState } from 'react';
import { Button, Modal, message } from 'antd';
import { MdDelete } from 'react-icons/md';
import { useCaseStudy } from '../../hooks/useCaseStudy'; // Adjust path as needed

const DeleteCase = ({ caseId, onDeleteSuccess }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { useDeleteCaseStudy } = useCaseStudy();
  const { mutate: deleteCaseStudy, isLoading: isDeleting } =
    useDeleteCaseStudy();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    if (!caseId) {
      message.error('Case ID is missing');
      return;
    }
    n;

    deleteCaseStudy(caseId, {
      onSuccess: () => {
        message.success('Case deleted successfully');
        setIsModalOpen(false);
        onDeleteSuccess?.();
      },
      onError: error => {
        console.error('Error deleting case:', error);
        message.error('Failed to delete case');
      },
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button onClick={showModal} icon={<MdDelete />} danger type="primary">
        Delete
      </Button>
      <Modal
        title="Confirm Delete"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Delete"
        confirmLoading={isDeleting}
      >
        <p>Are you sure you want to delete (archive) this case study?</p>
        <p>This action can be reversed from the admin panel if needed.</p>
      </Modal>
    </>
  );
};

export default DeleteCase;
